<div class="content-wrapper">
  <h5 class="form-section-title">
    <mat-icon>history</mat-icon>
    <span class="title-label">Historial de Accesos</span>
  </h5>
  <hr>
  <div class="table-responsive">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <!-- Columna Fecha y Hora -->
      <ng-container matColumnDef="attemptDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha y Hora</th>
        <td mat-cell *matCellDef="let log">
          {{ log.attemptDate | date: 'dd/MM/yyyy HH:mm:ss' }}
        </td>
      </ng-container>

      <!-- Columna IP -->
      <ng-container matColumnDef="ip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>IP</th>
        <td mat-cell *matCellDef="let log">{{ log.ip }}</td>
      </ng-container>


      <!-- Columna Estado -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Inicio de sesión</th>
        <td mat-cell *matCellDef="let log">
          <span [ngClass]="{ 'success': log.status === 1, 'failed': log.status === 2 }">
            {{ log.status === 1 ? 'Exitoso' : 'Fallido' }}
          </span>
        </td>
      </ng-container>

      <!-- Encabezados de la tabla -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <!-- Filas de la tabla -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- Paginador -->
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Seleccionar página">
  </mat-paginator>
</div>